<form [formGroup]="configurationFormBacklog">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="dataSelectionType" class="control-label required">
        {{'i18n.domain.export-configuration.configurations.forms.backlog.form-fields.dataSelectionTypes' | translate}}
      </label>
      <app-enum-drop-down-list formControlName="dataSelectionType" [showClearButton]="false"
        [enumType]="DataSelectionType" baseTranslationString='i18n.shared.dataSelectionTypes.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="configurationFormBacklog.get('dataSelectionType')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="backlogFilterLocations" class="control-label" [ngClass]="{'required': isLocationRequired}">
        {{'i18n.domain.export-configuration.configurations.forms.backlog.form-fields.backlog-filter-locations' | translate}}
      </label>
      <div class="col">
        <app-multi-select-filter [(values)]="selectedLocations"
          [getDataFunction]="getLocations.bind(this)" [type]="multiSelectItemFilter">
        </app-multi-select-filter>
      </div>
    </div>
  </div>
  @if (isLocationRequired) {
    <div class="form-row row">
      <div class="form-group col-md-12 error">
        <span class="alert alert-warning">
          {{'i18n.domain.export-configuration.configurations.forms.backlog.form-fields.brand-selection-hint' | translate}}: "{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.brand-inclusion' | translate}}"
        </span>
      </div>
    </div>
  }
</form>
